import React, { useState } from 'react';
import api from '../api/api';
import { useNavigate } from 'react-router-dom';
import ButtonLoading from './ButtonLoading';


const ChangePassword = () => {
    const navigate = useNavigate();
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword1, setNewPassword1] = useState('');
    const [newPassword2, setNewPassword2] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [showToLoginButton, setShowToLoginButton] = useState(false);

    const toLoginPage = () => { 
        navigate('/login')
    }

    const handleChangePassword = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        setSuccess('');
        
        try {
            const response = await api.post(`${process.env.REACT_APP_API_URL}/accounts/api/change-password/`, {
                old_password: oldPassword,
                new_password1: newPassword1,
                new_password2: newPassword2
            }, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            setSuccess("パスワードが変更されました。");
            setShowToLoginButton(true);
        } catch (error) {
            if (error.response && error.response.data) {
                setError(error.response.data.old_password || error.response.data.new_password || "エラーが発生しました。");
            } else {
                setError("サーバーエラーが発生しました。");
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className='background'>
            <div className="form-main">
                <h1>パスワード変更</h1>

                {success && <p style={{ color: 'green' }}>{success}</p>}
                {error && <p style={{ color: 'red' }}>{error}</p>}

                <form onSubmit={handleChangePassword}>
                    <input 
                        type="password" 
                        name="old_password" 
                        placeholder="現在のパスワード" 
                        required 
                        value={oldPassword}
                        onChange={(e) => setOldPassword(e.target.value)}
                        className="w-full border rounded-md p-2 mb-2"
                    />
                    <input 
                        type="password" 
                        name="new_password1" 
                        placeholder="新しいパスワード" 
                        required 
                        value={newPassword1}
                        onChange={(e) => setNewPassword1(e.target.value)}
                        className="w-full border rounded-md p-2 mb-2"
                    />
                    <input 
                        type="password" 
                        name="new_password2" 
                        placeholder="新しいパスワードの確認" 
                        required 
                        value={newPassword2}
                        onChange={(e) => setNewPassword2(e.target.value)}
                        className="w-full border rounded-md p-2 mb-2"
                    />
                    <button type="submit" className="btn" disabled={loading}>
                        {loading ? <ButtonLoading /> : "パスワードを変更"}
                    </button>
                    {showToLoginButton && 
                        <button type="submnit" className="btn to-login-button" onClick={toLoginPage} >ログインページへ移動</button>
                    }
                </form>
            </div>
        </div>
    );
}

export default ChangePassword;
